import { useTheme } from '../../hooks/useTheme'
import type { ReactNode } from 'react'

type FilterVariant = 'all' | 'active' | 'pending' | 'warning' | 'danger' | 'default' | 'brand'

interface FilterButtonProps {
  children: ReactNode
  isActive: boolean
  variant?: FilterVariant
  onClick: () => void
  className?: string
}

export function FilterButton({
  children,
  isActive,
  variant = 'default',
  onClick,
  className = '',
}: FilterButtonProps) {
  const theme = useTheme()
  
  const getVariantStyles = () => {
    if (!isActive) {
      return {
        backgroundColor: theme.cardBg,
        border: `1px solid ${theme.cardBorder}`,
        color: theme.textColor,
      }
    }
    
    switch (variant) {
      case 'all':
      case 'default':
        return {
          backgroundColor: 'rgba(0, 136, 204, 0.2)',
          border: '1px solid rgba(0, 136, 204, 0.5)',
          color: theme.textColor,
        }
      case 'active':
        return {
          backgroundColor: 'rgba(34, 197, 94, 0.2)',
          border: '1px solid rgba(34, 197, 94, 0.5)',
          color: theme.textColor,
        }
      case 'pending':
      case 'warning':
        return {
          backgroundColor: 'rgba(234, 179, 8, 0.2)',
          border: '1px solid rgba(234, 179, 8, 0.5)',
          color: theme.textColor,
        }
      case 'danger':
        return {
          backgroundColor: 'rgba(239, 68, 68, 0.2)',
          border: '1px solid rgba(239, 68, 68, 0.5)',
          color: theme.textColor,
        }
      case 'brand':
        return {
          backgroundColor: theme.brand.dark,
          border: `1px solid ${theme.brand.border}`,
          color: theme.textColor,
        }
      default:
        return {}
    }
  }
  
  return (
    <button
      onClick={onClick}
      className={`px-3 py-2 rounded-lg text-sm font-medium transition-all ${className}`}
      style={getVariantStyles()}
    >
      {children}
    </button>
  )
}
